import React, { FC } from 'react';
import { View as DefaultView } from 'react-native';
import { ThemeProps } from '../../../types/types';
import useThemeColor from '../../../hooks/useThemeColor';
export type ViewProps = ThemeProps & DefaultView['props'];

const View: FC<ViewProps> = (props) => {
  const { style, lightColor, darkColor, ...otherProps } = props;
  const backgroundColor = useThemeColor(
    { light: lightColor, dark: darkColor },
    'background',
  );

  return <DefaultView style={[{ backgroundColor }, style]} {...otherProps} />;
};

export default View;
